import { makeVar, useReactiveVar } from '@apollo/client';
import { isEmpty } from 'lodash';
import { SurfaceNodeUnion } from 'graphql/types';

interface GlobalLink {
  from: SurfaceNodeUnion;
  to?: null;
}

interface GlobalLinkOperations {
  addGlobalLink: (globalLink: GlobalLink) => void;
  removeGlobalLink: (globalLink: GlobalLink) => void;
  removeGlobalLinkByNodeId: (id: string) => void;
  clearGlobalLinks(): void;
  isGlobalLinkZoneEmpty(): boolean;
}

const globalLinksVar = makeVar<GlobalLink[]>([]);

function addGlobalLink(link: GlobalLink): void {
  globalLinksVar([link]);
}

function removeGlobalLink(link: GlobalLink): void {
  const globalLinks = globalLinksVar().filter(
    ({ from }) => from.id !== link.from.id,
  );

  globalLinksVar(globalLinks);
}

function clearGlobalLinks() {
  globalLinksVar([]);
}

function removeGlobalLinkByNodeId(id: string) {
  const nodeExistsInLink = globalLinksVar().some(({ from }) => from.id === id);

  if (nodeExistsInLink) {
    globalLinksVar(globalLinksVar().filter((link) => link.from.id !== id));
  }
}

function isGlobalLinkZoneEmpty() {
  return isEmpty(globalLinksVar());
}

const globalLinkOperations = {
  addGlobalLink,
  removeGlobalLink,
  clearGlobalLinks,
  removeGlobalLinkByNodeId,
  isGlobalLinkZoneEmpty,
};

export function useGlobalLinks(): [GlobalLink[], GlobalLinkOperations] {
  const globalLinks = useReactiveVar(globalLinksVar);

  return [globalLinks, globalLinkOperations];
}

export function useGlobalLinkOperations(): GlobalLinkOperations {
  return globalLinkOperations;
}
